import { render, staticRenderFns } from "./salereturns.vue?vue&type=template&id=7e0c2b5b"
import script from "./salereturns.vue?vue&type=script&lang=js"
export * from "./salereturns.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports